/**
 * Help pages (sections/bjaf-help-*.liquid).
 * - FAQ: search field and topic chips filter the questions in place; each chip shows how many questions match.
 *   An empty result shows the "Nothing on that yet" card.
 * - Country picker in the intro: choosing a country submits Shopify's localization form.
 */
(function () {
  if (window.bjafHelpReady) return;
  window.bjafHelpReady = true;

  function initFaq(root) {
    var input = root.querySelector('[data-bjaf-hp-search]');
    var chips = root.querySelectorAll('[data-bjaf-hp-chip]');
    var groups = root.querySelectorAll('[data-bjaf-hp-group]');
    var empty = root.querySelector('[data-bjaf-hp-empty]');
    var current = 'all';

    function update() {
      var term = input ? input.value.trim().toLowerCase() : '';
      var counts = { all: 0 };
      var shown = 0;

      groups.forEach(function (group) {
        var id = group.getAttribute('data-bjaf-hp-group');
        var inTopic = current === 'all' || current === id;
        var matches = 0;
        group.querySelectorAll('.bjaf-hp-q').forEach(function (q) {
          var hit = !term || q.textContent.toLowerCase().indexOf(term) > -1;
          if (hit) matches += 1;
          q.hidden = !(hit && inTopic);
          if (term && hit && inTopic) q.open = true;
        });
        counts[id] = matches;
        counts.all += matches;
        var visible = inTopic && matches > 0;
        group.hidden = !visible;
        if (visible) shown += 1;
      });

      chips.forEach(function (chip) {
        var id = chip.getAttribute('data-bjaf-hp-chip');
        var count = chip.querySelector('[data-bjaf-hp-count]');
        if (count) count.textContent = counts[id] != null ? counts[id] : '';
        chip.setAttribute('aria-pressed', id === current ? 'true' : 'false');
      });

      if (empty) empty.hidden = shown > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        current = chip.getAttribute('data-bjaf-hp-chip');
        update();
      });
    });
    if (input) input.addEventListener('input', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-bjaf-hp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-bjaf-hp-autosubmit]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
